var React = require('react');

function ArrowNextInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.0908 14.9766L9.69086 18.6856L13.0908 22.3946","stroke":"white","key":0}),React.createElement("path",{"d":"M9.69164 18.6835L27.3096 18.6836","stroke":"white","key":1}),React.createElement("circle",{"r":"18.0595","transform":"matrix(-1 0 0 1 18.5 18.5)","stroke":"white","strokeWidth":"0.880952","key":2})]);
}

ArrowNextInline.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = ArrowNextInline;

ArrowNextInline.default = ArrowNextInline;
